<p-dialog
  #noticiaDialog
  maximizable="true"
  header="{{ 'noticias_avisos.noticias.single' | translate }}"
  [(visible)]="show_noticia"
  [baseZIndex]="10000"
  [modal]="true"
  (onHide)="noticia = null"
  closeOnEscape="false"
  [style]="{ width: '50vw' }"
>
  <span
    ><i class="fas fa-calendar"></i>
    {{ "noticias_avisos.publicado_el" | translate }}
    {{ noticia?.fecha | date: "MMMM dd, yyyy" }}</span
  ><br />
  <span class="text-primary">{{ noticia?.nombre }}</span
  ><br /><br />
  <div [innerHTML]="noticia?.contenido"></div>
</p-dialog>

<div
  class="modal fade"
  bsModal
  #noticias_modal="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title pull-left text-primary">
          {{ "noticias_avisos.noticias.titulo" | translate }}
        </h5>
        <button
          (click)="noticias_modal.hide()"
          class="close pull-right"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="margin-bottom text-justify">
          {{ "noticias_avisos.noticias.click" | translate }}
        </div>
        <p-carousel
          [value]="noticias"
          [autoplayInterval]="7000"
          [circular]="true"
        >
          <ng-template let-noti pTemplate="item">
            <div (click)="select_noticia(noti)" class="noticia_box_carousel">
              <div class="small">
                <span
                  ><i class="fas fa-calendar"></i>
                  {{ noti.fecha | date: "MMMM dd, yyyy" }}</span
                ><br />
                <span class="text-primary strong">{{ noti.nombre }}</span
                ><br />
              </div>
              <img
                class="img-fluid"
                src="{{ noti.banner }}"
                src-fallback="./assets/img/undraw_profile.svg"
              />
            </div>
          </ng-template>
        </p-carousel>
      </div>
      <div class="modal-footer">
        <p-button
          styleClass="p-button-sm"
          pRipple
          label="{{ 'button.cerrar' | translate }}"
          (click)="noticias_modal.hide()"
          icon="pi pi-times"
        ></p-button>
      </div>
    </div>
  </div>
</div>
